import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Faq = ({ title, items }) => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 border-t border-[#E6E3DC]"
    >
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="flex items-center gap-4 mb-12 md:mb-16"
      >
        <span className="h-px w-10 bg-[#B0863A]" />
        <span className="overline text-[#7A8091]">{title}</span>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-16">
        <dl className="lg:col-span-10 lg:col-start-2">
          {items.map((item, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              data-testid="faq-item"
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 border-t border-[#E6E3DC] py-8 md:py-10"
            >
              <dt className="md:col-span-5 font-serif-display italic font-light text-[#171B26] text-xl md:text-2xl leading-snug tracking-tight">
                {item.q}
              </dt>
              <dd className="md:col-span-7 text-[#565C6B] text-base md:text-lg font-light leading-relaxed">
                {item.a}
              </dd>
            </motion.div>
          ))}
        </dl>
      </div>
    </section>
  );
};
